

<ion-content>
  <hr class="styled-divider">
  <div class="modal-content">
      <ion-grid>
        <ion-row>
          <ion-col><ion-icon name="help-circle-sharp"  color="primary"></ion-icon></ion-col>
          <ion-col size="10">
            <h4 class="d-m-header">{{modalProps?.header || 'Header'}}</h4>
            <div class="d-m-content">{{modalProps?.message || 'Message'}}</div>
          </ion-col>     
        </ion-row>
      </ion-grid>
    <hr class="simple-divider">
    <div class="flex-space-evenly button-group">
      <ion-button expand="block" fill="outline" color="primary" (click)="reject()">{{modalProps?.rejectBtnName || 'Cancel'}}</ion-button>
      <ion-button expand="block"  color="primary" (click)="accept()">{{modalProps?.acceptBtnName || 'Continue'}}</ion-button>
    </div>
  </div>
</ion-content>
